import { hygieneRules } from './hygiene';
import { objectRules } from './objects';
import { pageRules } from './page';
import { referenceRules } from './references';
import { structureRules } from './structure';
import { textRules } from './text';
import type { Category, Rule, Severity } from './types';

export interface RuleInfo {
  id: string;
  category: Category;
  title: string;
  severity: Severity;
}

/** Все правила в порядке показа: по категориям, внутри — по важности для студента. */
export const ALL_RULES: readonly Rule[] = [
  ...pageRules,
  ...textRules,
  ...structureRules,
  ...objectRules,
  ...referenceRules,
  ...hygieneRules,
];

/** Список правил без функций проверки — для настроек в интерфейсе (передаётся из Web Worker). */
export const ruleCatalog = (): RuleInfo[] => ALL_RULES.map(({ id, category, title, severity }) => ({ id, category, title, severity }));
